import { Link } from 'react-router-dom';
import './Stempel.css';
import { ReactNode, memo } from 'react';

interface StempelProps {
  children?: ReactNode;
}

const Stempel: React.FC<StempelProps> = memo(({ children }) => (
  <div id="center">
    <div id="right_column">
      <div className="right_column_front">
        <div className="right_content">
        <img
            src="/images/portrait.webp"
            alt="Сергей Мавроди"
            width="201"
            height="231" 
          />
          <br/>
          
          <img className='poem'
            src="/images/poem.webp"
            alt="Ганнибал"
            width="194"
            height="292" 
          />

          <Link to="/contacts" className="contacts-link" aria-label="Перейти на страницу Контакты">КОНТАКТЫ</Link>
          
          <Link to="/bewertungen" className="bewertungen-link" aria-label="Отзывы и Рецензии"></Link>

          <Link to="/museum" className="museum-link" aria-label="Музей"></Link>

          
        </div>
      </div>
    </div>

    <div id="left_column">
      <div className="left_column">
        <div className="left_column_top">
          <div className="left_column_bot_back">
            <div className="left_column_bot_front"></div>
          </div>
        </div>

        <div className="left_content">
          {children}
        </div>
      </div>
    </div>
  </div>
));

export default Stempel;